import { render, staticRenderFns } from "./PageTabs.vue?vue&type=template&id=260a5612&"
import script from "./PageTabs.vue?vue&type=script&lang=ts&"
export * from "./PageTabs.vue?vue&type=script&lang=ts&"
import style0 from "./PageTabs.vue?vue&type=style&index=0&id=260a5612&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports